import TxPage from "../components/TxPage";
import { PENTASYARUFAN_TABS } from "../lib/constants";

export default function Pentasyarufan() {
  return (
    <TxPage
      title="Pentasyarufan Dana"
      subtitle="Catat penyaluran dana keluar: Infaq/Sedekah/DSKL dan Zakat"
      tabs={PENTASYARUFAN_TABS}
      direction="out"
      partyField="recipient"
      partyLabel="Penerima Manfaat"
      testPrefix="pentasyarufan"
    />
  );
}
